$(document).ready(function() {
  var elem = document.querySelector(".seccion-reservacion-detalle");
  if (elem == null) {
    return;
  }

  let owlCarruselImagenes;

  let vueAppReservacionDetalle = new Vue({
    el: elem,
    data: {
      loader: false
    },
    mounted() {
      CheckMapaImagenes()

      Fancybox.bind('[data-fancybox="Terraza"]', {

      })
      Fancybox.bind('[data-fancybox="TerrazaTelefono"]', {

      })

      owlCarruselImagenes = $('.owl-carousel-telefono').owlCarousel({
        loop: false,
        margin: 0,
        dots: false,
        smartSpeed: 1500,
        nav: false,
        // dots: true,
        autoplay: true,
        items: 1,
        // navText : ['<div class="ms-nav-prev"></div>','<div class="ms-nav-next"></div>'],
      });

      var totalItems = $('.owl-item:not(.cloned)').length;

      $('#totalImages').text(totalItems);

      owlCarruselImagenes.on('changed.owl.carousel', function(event) {
        var currentIndex = event.item.index - event.relatedTarget._clones.length / 2;
        var currentItem = (currentIndex % totalItems + totalItems) % totalItems + 1; // Ajuste para índices negativos
        $('#currentImage').text(currentItem);
      })

    },
    methods: {
      setEstatus(estatus){

        swal({
          title: '¿'+estatus+' reservación?',
          icon: 'warning',
          buttons: { cancel: 'Cancelar', ok: 'Aceptar', },
          dangerMode: true,
        }).then((ok) => {
          if (ok) {
            vueAppReservacionDetalle.loader = true
            axios
              .post("/mi-perfil/reservaciones/"+reservacionId+"/actualizar-estatus",{
                estatus: estatus.toLowerCase()
              })
              .then((respuesta) => {
                vueAppReservacionDetalle.loader = false
                // $("#btnFinalizar").loader("hide")
                if (respuesta.data.error) {
                  swal({
                    icon: "info",
                    title: respuesta.data.error,
                    button: {
                      text: "Aceptar",
                      closeModal: true,
                    },
                  })
                  return
                }

                let mensajeEstatus = "rechazada"
                console.log(estatus.toLowerCase())
                if(estatus.toLowerCase() == "cancelar"){
                  mensajeEstatus = "cancelada"
                }
                else if(estatus.toLowerCase() == "aceptar"){
                  mensajeEstatus = "aceptada"
                }

                swal({
                  icon: "success",
                  title: "Reservación " + mensajeEstatus,
                  button: {
                    text: "Aceptar",
                    closeModal: true,
                  },
                }).finally(() => {
                  location.reload()
                })

              })
              .catch((error) => {
                ReportErrorLog(error)
                console.error(error)
                vueAppReservacionDetalle.loader = false
                swal({
                  icon: "info",
                  title: "Ocurrió un error inesperado",
                  button: {
                    text: "Aceptar",
                    closeModal: true,
                  },
                })
              })
          }
        });

      }
    }
  });
});
